import React, { useState } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import MainCalculatorsList from "./MainCalculators";

const TITLE = "Adhkars du Matin - Hisn al-Muslim - Adhkars du Matin et du Soir";
const DESCRIPTION = "Adhkars du matin de Hisn al-Muslim. Appuyez sur le cercle pour enregistrer chaque dhikr avec un compteur automatique qui calcule le requis et le restant pour chaque adhkar du matin.";
const KEYWORDS = "adhkars du matin, hisn al-muslim, adhkars du matin et du soir, adhkars islamiques, tasbeeh du matin";
const OG_URL = "https://do-calculate.com/calculator/fr/athkar-alsabah/";

const athkarList = [
  {
    key: "ayat_kursi",
    title: "آية الكرسي",
    titleFr: "Verset du Trône (Ayat al-Kursi)",
    text: "أَعُوذُ بِاللهِ مِنَ الشَّيْطَانِ الرَّجِيمِ\nاللّهُ لاَ إِلَـهَ إِلاَّ هُوَ الْحَيُّ الْقَيُّومُ لاَ تَأْخُذُهُ سِنَةٌ وَلاَ نَوْمٌ لَّهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الأَرْضِ مَن ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلاَّ بِإِذْنِهِ يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ وَلاَ يُحِيطُونَ بِشَيْءٍ مِّنْ عِلْمِهِ إِلاَّ بِمَا شَاء وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالأَرْضَ وَلاَ يَؤُودُهُ حِفْظُهُمَا وَهُوَ الْعَلِيُّ الْعَظِيمُ",
    fadl: "من قالها حين يصبح أجير من الجن حتى يمسى",
    count: 1,
  },
  {
    key: "ikhlas",
    title: "سورة الإخلاص",
    titleFr: "Sourate Al-Ikhlas",
    text: "بِسْمِ اللهِ الرَّحْمنِ الرَّحِيم\nقُلْ هُوَ ٱللَّهُ أَحَدٌ، ٱللَّهُ ٱلصَّمَدُ، لَمْ يَلِدْ وَلَمْ يُولَدْ، وَلَمْ يَكُن لَّهُۥ كُفُوًا أَحَدٌۢ",
    fadl: "من قالها حين يصبح وحين يمسى كفته من كل شىء",
    count: 3,
  },
  {
    key: "falaq",
    title: "سورة الفلق",
    titleFr: "Sourate Al-Falaq",
    text: "بِسْمِ اللهِ الرَّحْمنِ الرَّحِيم\nقُلْ أَعُوذُ بِرَبِّ ٱلْفَلَقِ، مِن شَرِّ مَا خَلَقَ، وَمِن شَرِّ غَاسِقٍ إِذَا وَقَبَ، وَمِن شَرِّ ٱلنَّفَّٰثَٰتِ فِى ٱلْعُقَدِ، وَمِن شَرِّ حَاسِدٍ إِذَا حَسَدَ",
    fadl: "",
    count: 3,
  },
  {
    key: "nas",
    title: "سورة الناس",
    titleFr: "Sourate An-Nas",
    text: "بِسْمِ اللهِ الرَّحْمنِ الرَّحِيم\nقُلْ أَعُوذُ بِرَبِّ ٱلنَّاسِ، مَلِكِ ٱلنَّاسِ، إِلَٰهِ ٱلنَّاسِ، مِن شَرِّ ٱلْوَسْوَاسِ ٱلْخَنَّاسِ، ٱلَّذِى يُوَسْوِسُ فِى صُدُورِ ٱلنَّاسِ، مِنَ ٱلْجِنَّةِ وَٱلنَّاسِ",
    fadl: "",
    count: 3,
  },
  {
    key: "duaa_sabah",
    title: "دعاء الصباح",
    titleFr: "Invocation du Matin",
    text: "أَصْـبَحْنا وَأَصْـبَحَ المُـلْكُ لله وَالحَمدُ لله، لا إلهَ إلاّ اللّهُ وَحدَهُ لا شَريكَ لهُ، لهُ المُـلكُ ولهُ الحَمْـد، وهُوَ على كلّ شَيءٍ قدير، رَبِّ أسْـأَلُـكَ خَـيرَ ما في هـذا اليوم وَخَـيرَ ما بَعْـدَه، وَأَعـوذُ بِكَ مِنْ شَـرِّ ما في هـذا اليوم وَشَرِّ ما بَعْـدَه، رَبِّ أَعـوذُبِكَ مِنَ الْكَسَـلِ وَسـوءِ الْكِـبَر، رَبِّ أَعـوذُ بِكَ مِنْ عَـذابٍ في النّـارِ وَعَـذابٍ في القَـبْر",
    fadl: "",
    count: 1,
  },
  {
    key: "sayyid_istighfar",
    title: "سيد الاستغفار",
    titleFr: "La meilleure demande de pardon",
    text: "اللّهـمَّ أَنْتَ رَبِّـي لا إلهَ إلاّ أَنْتَ، خَلَقْتَنـي وَأَنا عَبْـدُك، وَأَنا عَلـى عَهْـدِكَ وَوَعْـدِكَ ما اسْتَـطَعْـت، أَعـوذُبِكَ مِنْ شَـرِّ ما صَنَـعْت، أَبـوءُ لَـكَ بِنِعْـمَتِـكَ عَلَـيَّ وَأَبـوءُ بِذَنْـبي فَاغْفـِرْ لي فَإِنَّـهُ لا يَغْـفِرُ الذُّنـوبَ إِلاّ أَنْتَ",
    fadl: "من قالها موقناً بها حين يصبح ومات من يومه دخل الجنة",
    count: 1,
  },
  {
    key: "rida",
    title: "الرضا بالله رباً",
    titleFr: "Se satisfaire d'Allah comme Seigneur",
    text: "رَضيـتُ بِاللهِ رَبَّـاً وَبِالإسْلامِ ديـناً وَبِمُحَـمَّدٍ صلى الله عليه وسلم نَبِيّـاً",
    fadl: "من قالها حين يصبح وحين يمسى كان حقاً على الله أن يرضيه يوم القيامة",
    count: 3,
  },
  {
    key: "shahada_tawheed",
    title: "الشهادة على التوحيد",
    titleFr: "Témoignage de l'Unicité divine",
    text: "اللّهُـمَّ إِنِّـي أَصْبَـحْتُ أُشْـهِدُك، وَأُشْـهِدُ حَمَلَـةَ عَـرْشِـك، وَمَلَائِكَتَكَ، وَجَمـيعَ خَلْـقِك، أَنَّـكَ أَنْـتَ اللهُ لا إلهَ إلاّ أَنْـتَ وَحْـدَكَ لا شَريكَ لَـك، وَأَنَّ مُحَمّـداً عَبْـدُكَ وَرَسـولُـك",
    fadl: "من قالها أعتقه الله من النار",
    count: 4,
  },
  {
    key: "shukr_nima",
    title: "شكر النعمة",
    titleFr: "Action de grâce pour les bienfaits",
    text: "اللّهُـمَّ ما أَصْبَـحَ بي مِـنْ نِعْـمَةٍ أَو بِأَحَـدٍ مِـنْ خَلْـقِك، فَمِـنْكَ وَحْـدَكَ لا شريكَ لَـك، فَلَـكَ الْحَمْـدُ وَلَـكَ الشُّكْـر",
    fadl: "من قالها حين يصبح أدى شكر يومه",
    count: 1,
  },
  {
    key: "hasbiyallah",
    title: "حسبي الله",
    titleFr: "Allah me suffit",
    text: "حَسْبِـيَ اللّهُ لا إلهَ إلاّ هُوَ عَلَـيهِ تَوَكَّـلتُ وَهُوَ رَبُّ العَرْشِ العَظـيم",
    fadl: "من قالها كفاه الله ما أهمه من أمر الدنيا والآخرة",
    count: 7,
  },
  {
    key: "bismillah_hifz",
    title: "بسم الله الحفظ",
    titleFr: "Au nom d'Allah (Protection)",
    text: "بِسـمِ اللهِ الذي لا يَضُـرُّ مَعَ اسمِـهِ شَيءٌ في الأرْضِ وَلا في السّمـاءِ وَهـوَ السّمـيعُ العَلـيم",
    fadl: "لم يضره شيء حتى يمسى",
    count: 3,
  },
  {
    key: "hayat_mamat",
    title: "دعاء الحياة والممات",
    titleFr: "Invocation de la Vie et de la Mort",
    text: "اللّهُـمَّ بِكَ أَصْـبَحْنا وَبِكَ أَمْسَـينا، وَبِكَ نَحْـيا وَبِكَ نَمُـوتُ وَإِلَـيْكَ النُّـشُور",
    fadl: "",
    count: 1,
  },
  {
    key: "fitrat_islam",
    title: "فطرة الإسلام",
    titleFr: "La nature primordiale de l'Islam",
    text: "أَصْبَـحْـنا عَلَى فِطْرَةِ الإسْلاَمِ، وَعَلَى كَلِمَةِ الإِخْلاَصِ، وَعَلَى دِينِ نَبِيِّنَا مُحَمَّدٍ صَلَّى اللهُ عَلَيْهِ وَسَلَّمَ، وَعَلَى مِلَّةِ أَبِينَا إبْرَاهِيمَ حَنِيفاً مُسْلِماً وَمَا كَانَ مِنَ المُشْرِكِينَ",
    fadl: "",
    count: 1,
  },
  {
    key: "subhan_full",
    title: "سبحان الله وبحمده (الكاملة)",
    titleFr: "Gloire et louange à Allah (complète)",
    text: "سُبْحـانَ اللهِ وَبِحَمْـدِهِ عَدَدَ خَلْـقِه، وَرِضـا نَفْسِـه، وَزِنَـةَ عَـرْشِـه، وَمِـدادَ كَلِمـاتِـه",
    fadl: "",
    count: 3,
  },
  {
    key: "afiya",
    title: "دعاء العافية",
    titleFr: "Invocation pour la santé",
    text: "اللّهُـمَّ عافِـني في بَدَنـي، اللّهُـمَّ عافِـني في سَمْـعي، اللّهُـمَّ عافِـني في بَصَـري، لا إلهَ إلاّ أَنْـتَ",
    fadl: "",
    count: 3,
  },
  {
    key: "kufr_faqr",
    title: "الاستعاذة من الكفر والفقر",
    titleFr: "Protection de l'incroyance et la pauvreté",
    text: "اللّهُـمَّ إِنّـي أَعـوذُ بِكَ مِنَ الْكُـفر، وَالفَـقْر، وَأَعـوذُ بِكَ مِنْ عَذابِ القَـبْر، لا إلهَ إلاّ أَنْـتَ",
    fadl: "",
    count: 3,
  },
  {
    key: "afw_afiya",
    title: "دعاء العفو والعافية",
    titleFr: "Invocation du pardon et de la santé",
    text: "اللّهُـمَّ إِنِّـي أسْـأَلُـكَ العَـفْوَ وَالعـافِـيةَ في الدُّنْـيا وَالآخِـرَة، اللّهُـمَّ إِنِّـي أسْـأَلُـكَ العَـفْوَ وَالعـافِـيةَ في ديني وَدُنْـيايَ وَأهْـلي وَمالـي، اللّهُـمَّ اسْتُـرْ عـوْراتي وَآمِـنْ رَوْعاتـي، اللّهُـمَّ احْفَظْـني مِن بَـينِ يَدَيَّ وَمِن خَلْفـي وَعَن يَمـيني وَعَن شِمـالي، وَمِن فَوْقـي، وَأَعـوذُ بِعَظَمَـتِكَ أَن أُغْـتالَ مِن تَحْتـي",
    fadl: "",
    count: 1,
  },
  {
    key: "ya_hayy",
    title: "يا حي يا قيوم",
    titleFr: "Ô Vivant, ô Subsistant",
    text: "يَا حَيُّ يَا قيُّومُ بِرَحْمَتِكَ أسْتَغِيثُ، أصْلِحْ لِي شَأنِي كُلَّهُ، وَلاَ تَكِلْنِي إلَى نَفْسِي طَـرْفَةَ عَيْنٍ",
    fadl: "",
    count: 3,
  },
  {
    key: "khayr_yawm",
    title: "دعاء خير اليوم",
    titleFr: "Invocation pour une belle journée",
    text: "أَصْبَـحْـنا وَأَصْبَـحَ المُـلكُ للهِ رَبِّ العـالَمـين، اللّهُـمَّ إِنِّـي أسْـأَلُـكَ خَـيْرَ هـذا الـيَوْم، فَـتْحَهُ، وَنَصْـرَهُ، وَنـورَهُ وَبَـرَكَتَـهُ، وَهُـداهُ، وَأَعـوذُ بِـكَ مِـنْ شَـرِّ ما فـيهِ وَشَـرِّ ما بَعْـدَه",
    fadl: "",
    count: 1,
  },
  {
    key: "shar_nafs",
    title: "الاستعاذة من شر النفس",
    titleFr: "Protection du mal de l'âme",
    text: "اللّهُـمَّ عالِـمَ الغَـيْبِ وَالشّـهادَةِ فاطِـرَ السّماواتِ وَالأرْضِ رَبَّ كـلِّ شَـيءٍ وَمَليـكَه، أَشْهَـدُ أَنْ لا إِلـهَ إِلاّ أَنْت، أَعـوذُ بِكَ مِن شَـرِّ نَفْسـي وَمِن شَـرِّ الشَّيْـطانِ وَشِرْكِهِ، وَأَنْ أَقْتَـرِفَ عَلـى نَفْسـي سوءاً أَوْ أَجُـرَّهُ إِلـى مُسْـلِم",
    fadl: "",
    count: 1,
  },
  {
    key: "kalimat_allah",
    title: "الاستعاذة بكلمات الله",
    titleFr: "Protection par les paroles d'Allah",
    text: "أَعـوذُ بِكَلِمـاتِ اللّهِ التّـامّـاتِ مِنْ شَـرِّ ما خَلَـق",
    fadl: "",
    count: 3,
  },
  {
    key: "salawat",
    title: "الصلاة على النبي ﷺ",
    titleFr: "Prière sur le Prophète ﷺ",
    text: "اللَّهُمَّ صَلِّ وَسَلِّمْ وَبَارِكْ على نَبِيِّنَا مُحمَّد",
    fadl: "من صلى عليه حين يصبح وحين يمسى أدركته شفاعته يوم القيامة",
    count: 10,
  },
  {
    key: "shirk",
    title: "الاستعاذة من الشرك",
    titleFr: "Protection contre l'association à Allah",
    text: "اللَّهُمَّ إِنَّا نَعُوذُ بِكَ مِنْ أَنْ نُشْرِكَ بِكَ شَيْئًا نَعْلَمُهُ، وَنَسْتَغْفِرُكَ لِمَا لَا نَعْلَمُهُ",
    fadl: "",
    count: 3,
  },
  {
    key: "hamm_huzn",
    title: "الاستعاذة من الهم والحزن",
    titleFr: "Protection de l'angoisse et la tristesse",
    text: "اللَّهُمَّ إِنِّي أَعُوذُ بِكَ مِنَ الْهَمِّ وَالْحَزَنِ، وَأَعُوذُ بِكَ مِنَ الْعَجْزِ وَالْكَسَلِ، وَأَعُوذُ بِكَ مِنَ الْجُبْنِ وَالْبُخْلِ، وَأَعُوذُ بِكَ مِنْ غَلَبَةِ الدَّيْنِ وَقَهْرِ الرِّجَالِ",
    fadl: "",
    count: 3,
  },
  {
    key: "istighfar_azeem",
    title: "الاستغفار العظيم",
    titleFr: "La grande demande de pardon",
    text: "أسْتَغْفِرُ اللهَ العَظِيمَ الَّذِي لاَ إلَهَ إلاَّ هُوَ، الحَيُّ القَيُّومُ، وَأتُوبُ إلَيهِ",
    fadl: "",
    count: 3,
  },
  {
    key: "hamd_jalal",
    title: "الحمد على الجلال",
    titleFr: "Louange à la Majesté divine",
    text: "يَا رَبِّ، لَكَ الْحَمْدُ كَمَا يَنْبَغِي لِجَلَالِ وَجْهِكَ، وَلِعَظِيمِ سُلْطَانِكَ",
    fadl: "",
    count: 3,
  },
  {
    key: "ilm_rizq",
    title: "طلب العلم والرزق",
    titleFr: "Demande de savoir et de subsistance",
    text: "اللَّهُمَّ إِنِّي أَسْأَلُكَ عِلْمًا نَافِعًا، وَرِزْقًا طَيِّبًا، وَعَمَلًا مُتَقَبَّلًا",
    fadl: "",
    count: 1,
  },
  {
    key: "tawakkul",
    title: "التوكل والحول",
    titleFr: "Confiance en Allah et Sa puissance",
    text: "اللَّهُمَّ أَنْتَ رَبِّي لا إِلَهَ إِلا أَنْتَ، عَلَيْكَ تَوَكَّلْتُ، وَأَنْتَ رَبُّ الْعَرْشِ الْعَظِيمِ، مَا شَاءَ اللَّهُ كَانَ وَمَا لَمْ يَشَأْ لَمْ يَكُنْ، وَلا حَوْلَ وَلا قُوَّةَ إِلا بِاللَّهِ الْعَلِيِّ الْعَظِيمِ",
    fadl: "",
    count: 1,
  },
  {
    key: "la_ilaha_100",
    title: "لا إله إلا الله (١٠٠)",
    titleFr: "Il n'y a de dieu qu'Allah (100 fois)",
    text: "لَا إلَه إلّا اللهُ وَحْدَهُ لَا شَرِيكَ لَهُ، لَهُ الْمُلْكُ وَلَهُ الْحَمْدُ وَهُوَ عَلَى كُلِّ شَيْءٍ قَدِيرٌ",
    fadl: "كانت له عدل عشر رقاب، وكتبت له مئة حسنة، ومحيت عنه مئة سيئة",
    count: 100,
  },
  {
    key: "subhan_100",
    title: "سبحان الله وبحمده (١٠٠)",
    titleFr: "Gloire et louange à Allah (100 fois)",
    text: "سُبْحـانَ اللهِ وَبِحَمْـدِهِ",
    fadl: "حُطَّتْ خَطَايَاهُ وَإِنْ كَانَتْ مِثْلَ زَبَدِ الْبَحْرِ",
    count: 100,
  },
  {
    key: "istighfar_100",
    title: "الاستغفار (١٠٠)",
    titleFr: "Demande de pardon (100 fois)",
    text: "أسْتَغْفِرُ اللهَ وَأتُوبُ إلَيْهِ",
    fadl: "مائة حسنة، ومُحيت عنه مائة سيئة، وكانت له حرزاً من الشيطان حتى يمسى",
    count: 100,
  },
];

const playDoneSound = () => {
  try {
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    [523, 659, 784].forEach((freq, i) => {
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();
      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);
      oscillator.type = "sine";
      oscillator.frequency.value = freq;
      const t = audioContext.currentTime + i * 0.13;
      gainNode.gain.setValueAtTime(0.2, t);
      gainNode.gain.exponentialRampToValueAtTime(0.001, t + 0.3);
      oscillator.start(t);
      oscillator.stop(t + 0.3);
    });
  } catch (error) {
    console.log("Audio play failed:", error);
  }
};

const AthkarAlSabah = () => {
  const initialCounts = {};
  athkarList.forEach((a) => { initialCounts[a.key] = 0; });

  const [counts, setCounts] = useState(initialCounts);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const handleIncrement = (key, target) => {
    setCounts((prev) => {
      const newCount = (prev[key] || 0) + 1;
      if (newCount === target) {
        playDoneSound();
        setSnackbarMessage(`Félicitations ! Vous avez accompli ce dhikr ✅`);
        setSnackbarOpen(true);
        setTimeout(() => setSnackbarOpen(false), 4000);
      }
      return { ...prev, [key]: newCount };
    });
  };

  const handleDecrement = (key) => {
    setCounts((prev) => ({
      ...prev,
      [key]: Math.max((prev[key] || 0) - 1, 0),
    }));
  };

  const handleReset = (key) => {
    setCounts((prev) => ({ ...prev, [key]: 0 }));
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />

      <div className="row">
        <div className="col-12 col-md-8">
          <div className="bg-success text-white text-center" style={{ height: "50px", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <h1 style={{ fontSize: "17px", margin: 0 }}>
              Adhkars du Matin - Hisn al-Muslim
            </h1>
          </div>

          <div
            className="border border-light shadow-lg p-4 rounded"
            style={{
              backgroundColor: "#f8f9fa",
              borderRadius: "10px",
              boxShadow: "0px 4px 15px rgba(0,0,0,0.1)",
            }}
          >
            <div className="row">
              <div>
                <p>
                  Les adhkars du matin sont des invocations et des dhikrs transmis de Hisn al-Muslim,
                  récités le matin pour la protection et la fortification de votre journée. Appuyez sur le
                  cercle pour enregistrer chaque tasbeeh, et utilisez le bouton "Diminuer" pour corriger
                  le compte ou "Réinitialiser" pour recommencer.{" "}
                  <b>
                    Le compteur affiche le requis et le restant pour chaque dhikr, et émet un son
                    d'alerte à son accomplissement.
                  </b>
                </p>
                <p>
                  Vous pouvez suivre votre progression dans chaque dhikr et savoir combien il vous reste
                  pour le compléter, ce qui vous aide à vous engager quotidiennement dans les adhkars du
                  matin facilement. Que Allah vous récompense pour votre attachement au dhikr.
                </p>
              </div>
            </div>

            {athkarList.map((item) => {
              const current = counts[item.key] || 0;
              const isDone = current >= item.count;
              const remaining = Math.max(item.count - current, 0);

              return (
                <div className="row" key={item.key} style={{ paddingBottom: "15px" }}>
                  <div className="col calculatorStyle">
                    <div className="p-3 mb-2 bg-success text-white text-center">
                      <h2 style={{ fontSize: "22px", marginBottom: "4px" }}>
                        {item.title}
                      </h2>
                      <p style={{ fontSize: "14px", color: "#d4edda", margin: "0 0 4px 0", fontStyle: "italic" }}>
                        {item.titleFr}
                      </p>
                      {item.fadl && (
                        <p style={{ fontSize: "13px", color: "#d4edda", margin: 0 }}>
                          ✦ {item.fadl}
                        </p>
                      )}
                    </div>

                    <hr />

                    <div dir="rtl">
                      <p style={{ fontSize: "18px", lineHeight: "2", textAlign: "center", color: "#333", whiteSpace: "pre-line" }}>
                        {item.text}
                      </p>

                      <hr />

                      <div className="text-center my-4">
                        <div
                          style={{
                            background: isDone
                              ? "linear-gradient(135deg, #d4edda 0%, #a8d5b5 100%)"
                              : "linear-gradient(135deg, #ffffff 0%, #e0f7fa 100%)",
                            color: isDone ? "#198754" : "#4caf50",
                            borderRadius: "50%",
                            width: "300px",
                            height: "300px",
                            fontSize: "70px",
                            fontWeight: "bold",
                            margin: "0 auto",
                            boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
                            cursor: isDone ? "default" : "pointer",
                            userSelect: "none",
                            alignItems: "center",
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "column",
                          }}
                          onClick={() => !isDone && handleIncrement(item.key, item.count)}
                        >
                          {current}
                          {isDone && (
                            <span style={{ fontSize: "20px", display: "block", marginTop: "8px" }}>✅</span>
                          )}
                        </div>
                      </div>

                      <div className="text-center" style={{ fontSize: "16px", color: "#198754", marginBottom: "12px" }}>
                        Requis : <strong>{item.count}</strong> &nbsp;|&nbsp; Restant : <strong>{remaining}</strong>
                      </div>

                      <br />

                      <div className="text-center mt-2">
                        <div style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap" }}>
                          <button
                            className="text-white px-4 py-2"
                            style={{
                              background: "linear-gradient(135deg, #f44336 0%, #e57373 100%)",
                              borderRadius: "20px",
                              fontSize: "16px",
                              fontWeight: "bold",
                              border: "none",
                              boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
                              transition: "background 0.3s",
                              padding: "15px",
                              cursor: "pointer",
                            }}
                            onClick={() => handleDecrement(item.key)}
                          >
                            Diminuer
                          </button>
                          <button
                            className="text-white px-4 py-2"
                            style={{
                              background: "linear-gradient(135deg, #2196f3 0%, #64b5f6 100%)",
                              borderRadius: "20px",
                              fontSize: "16px",
                              fontWeight: "bold",
                              border: "none",
                              boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
                              transition: "background 0.3s",
                              padding: "15px",
                              cursor: "pointer",
                            }}
                            onClick={() => handleReset(item.key)}
                          >
                            Réinitialiser
                          </button>
                        </div>

                        {isDone && (
                          <div
                            className="mt-3"
                            style={{
                              backgroundColor: "#d4edda",
                              color: "#155724",
                              borderRadius: "10px",
                              padding: "10px",
                              fontSize: "15px",
                              fontWeight: "bold",
                            }}
                          >
                            ✅ Vous avez accompli ce dhikr, que Allah vous récompense
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}

            <hr />
            <div className="row">
              <RelatedLinks />
              <hr style={{ width: "100%" }} />
            </div>
          </div>
        </div>

        <div className="col">
          <MainCalculatorsList />
          <br />
        </div>
      </div>

      {snackbarOpen && (
        <div
          style={{
            position: "fixed",
            top: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "#198754",
            color: "white",
            padding: "14px 24px",
            borderRadius: "8px",
            fontSize: "15px",
            fontWeight: "bold",
            boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
            zIndex: 9999,
          }}
        >
          {snackbarMessage}
        </div>
      )}
    </div>
  );
};

export default AthkarAlSabah;
